import React, { useEffect } from 'react';
import { UpNextArticle } from 'data/SingleArticle/types';
import { UpNextCard } from './UpNextCard';

type Props = {
  article: UpNextArticle | null;
  slugToExclude: string;
  /**
   * Useful when you want to send the UpNext Article slug
   * to the consumer of this component.
   */
  onUpNextArticleSlugReady?: (slug: string) => void;
};

export const UpNext = ({
  article,
  onUpNextArticleSlugReady = () => {},
}: Props) => {
  useEffect(() => {
    const upNextArticleSlug = article?.slug || '';

    onUpNextArticleSlugReady(upNextArticleSlug);
  }, [article?.slug, onUpNextArticleSlugReady]);

  if (article?.slug) {
    return <UpNextCard article={article} />;
  }

  return null;
};
